<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">فرم ثبت اطلاعات تجهیز بهفا</h5>
      <form [formGroup]="AddNewDeviceBehfa" (submit)="SubmitAddNewDevice()">

        <input type="hidden" formControlName="id" />

        <h5>کلیات</h5>
        <br/>

        <div  class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Group</label>
            <select class="custom-select" formControlName="GroupId"  (change)="GroupChange()">
              <option value="0">انتخاب کنید</option>
              <option *ngFor="let item of DataList_DeviceGroup_Parent" [value]="item.id">{{item.title}}</option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Sub Group</label>
            <select class="custom-select" formControlName="SubGroupId" >
              <option value="0">انتخاب کنید</option>
              <option *ngFor="let item of DataList_DeviceGroup_Child2" [value]="item.id">{{item.title}}</option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">تعداد</label>
            <input formControlName="count" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_count().valid && get_Form_count().touched" class="form-text text-muted MyErrorRedColor">تعداد را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">type</label>
            <input formControlName="type" type="text" style="font-family: Arial, Helvetica, sans-serif;" class="form-control EnglishClm"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_type().valid && get_Form_type().touched" class="form-text text-muted MyErrorRedColor">type را وارد نمائید.</small>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Description</label>
            <input formControlName="Description" type="text" style="font-family: Arial, Helvetica, sans-serif;" class="form-control EnglishClm"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Description().valid && get_Form_Description().touched" class="form-text text-muted MyErrorRedColor">Description را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">نیاز به کالیبراسیون</label>
            <select class="custom-select" (change)="NeedCalibration_Change()" formControlName="NeedCalibration" >
              <option value="1">دارد</option>
              <option value="0">ندارد</option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">کمد</label>
            <select class="custom-select"  formControlName="Cabinet_id" >
              <option value="0">بدون کمد</option>
              <option *ngFor="let item of DataList_Cabinet" [value]="item.id">{{item.title}} - {{item.dsc}}</option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">رده بندی تجهیز</label>
            <select class="custom-select" formControlName="CategoryId">
              <option value="0">انتخاب کنید</option>
              <option value="1">Reference</option>
              <option value="2">Secondary</option>
              <option value="3">Working</option>
            </select>
          </div>
        </div>


        <br/>
        <hr/>
        <h5>اطلاعات تجهیز</h5>
        <br/>

        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Manufacturer</label>
            <input formControlName="Manufacturer" type="text"  style="font-family: Arial, Helvetica, sans-serif;"  class="form-control EnglishClm"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Manufacturer().valid && get_Form_Manufacturer().touched" class="form-text text-muted MyErrorRedColor">Manufacturer را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Model</label>
            <input formControlName="Model" type="text"  style="font-family: Arial, Helvetica, sans-serif;"  class="form-control EnglishClm"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Model().valid && get_Form_Model().touched" class="form-text text-muted MyErrorRedColor">Model را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Code BEHFA</label>
            <input formControlName="CodeBEHFA" type="text"  style="font-family: Arial, Helvetica, sans-serif;"  class="form-control EnglishClm"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_CodeBEHFA().valid && get_Form_CodeBEHFA().touched" class="form-text text-muted MyErrorRedColor">Code BEHFA را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">سریال</label>
            <input formControlName="Serial" type="text"    class="form-control "  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Serial().valid && get_Form_Serial().touched" class="form-text text-muted MyErrorRedColor">سریال را وارد نمائید.</small>
          </div>

        </div>

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">کشور سازنده</label>
            <input formControlName="Countery" type="text"   class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Countery().valid && get_Form_Countery().touched" class="form-text text-muted MyErrorRedColor">کشور سازنده را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">فروشنده - پیمانکار</label>
            <select class="custom-select" (change)="ReadData_Contractor_Seller()" formControlName="SellerContractor" >
              <option value="0">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Contractor" [value]="item.id">{{item.title}}</option>
            </select>
          </div>

          <div class="form-group col-md-4" >
            <label for="exampleInputEmail1">فروشنده - مشتری</label>
            <select class="custom-select" formControlName="Seller" >
              <option value="0">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Contractor_Seller" [value]="item.id">{{item.title}}</option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">تاریخ خرید</label>
            <input type="text" formControlName="dateBuy"  #datepickerBuy placeholder="اینجا تایپ کنید ..."   class="form-control" />
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerBuy"></ng-persian-datepicker>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">تاریخ راه اندازی</label>
            <input type="text" formControlName="dateRun" #datepickerRun  placeholder="اینجا تایپ کنید ..."  class="form-control" />
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerRun"></ng-persian-datepicker>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">قیمت</label>
            <input formControlName="Price" type="number"   class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Price().valid && get_Form_Price().touched" class="form-text text-muted MyErrorRedColor">قیمت را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">واحد پولی</label>
            <select class="custom-select" formControlName="PriceVahed">
              <option value="0">انتخاب نمائید</option>
              <option *ngFor="let item of DataList_Money" [value]="item.id">{{item.title}}</option>
            </select>
          </div>
          <div class="form-group col-md-2">
            <label for="exampleInputEmail1">
              تعمیرکننده مجاز - پیمانکار

            </label>
            <select class="custom-select" (change)="ReadData_Contractor_Fixer()" formControlName="FixerContractor" >
              <option value="0">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Contractor" [value]="item.id">{{item.title}}</option>
            </select>

          </div>
          <div class="form-group col-md-4" >
            <label for="exampleInputEmail1">
              تعمیرکننده مجاز - مشتری
              <button (click)="OnAdd_RabetMasolCustomer_Fixer()"  type="button" [disabled]="get_Form_Fixer().value =='0'"  class="btn  btn-success" ><i class="fa  fa-plus-circle"></i> </button>
            </label>
            <select class="custom-select" formControlName="Fixer" >
              <option value="0">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Contractor_Fixer" [value]="item.id">{{item.title}}</option>
            </select>
            <table class="mb-0 table table-bordered table-3 text-center table-striped" *ngIf="RabetMasolCustomer_Fixer.length>0">
              <tr class="bg-warning" *ngFor="let item of RabetMasolCustomer_Fixer">
                  <td>
                    {{item.title}}
                  </td>
                  <td>
                    <a style="cursor: pointer;"  (click)="RabetMasolCustomer_Fixer_Delete(RabetMasolCustomer_Fixer.indexOf(item))"><i class="fa fa-remove"></i> حذف </a>
                  </td>
              </tr>
            </table>
          </div>


        </div>

        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">وضعیت اولیه</label>
            <select class="custom-select" formControlName="InitialStatus" >
              <option value="-1">انتخاب کنید</option>
              <option value="1">کارکرده</option>
              <option value="0">نو</option>
            </select>
          </div>

          <div class="form-group col-md-3" [hidden]="get_Form_NeedCalibration().value=='0'">
            <label for="exampleInputEmail1">دوره کالیبراسیون(ماه)</label>
            <input formControlName="CalibrationPeriod" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_CalibrationPeriod().valid && get_Form_CalibrationPeriod().touched" class="form-text text-muted MyErrorRedColor">دوره کالیبراسیون(ماه) را وارد نمائید.</small>
          </div>



          <div class="form-group col-md-3" [hidden]="get_Form_NeedCalibration().value=='0'">
            <label for="exampleInputEmail1">زمان هشدار قبل از انقضاء کالیبراسیون(روز)</label>
            <select class="custom-select" formControlName="WarningTime" >
              <option value="0">انتخاب کنید</option>
              <option *ngFor="let item of DayList" [value]="item">{{item}} روز</option>
            </select>
          </div>

        </div>

        <br/>
        <hr/>
        <h5>گستره کاری</h5>
        <br/>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">کمینه</label>
            <input formControlName="GostarehMin" type="number"  class="form-control EnglishClm"  placeholder="اینجا تایپ کنید ...">
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">بیشینه</label>
            <input formControlName="GostarehMax" type="number"  class="form-control EnglishClm"  placeholder="اینجا تایپ کنید ...">
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">زینه</label>
            <input formControlName="Zineh" type="number"  class="form-control EnglishClm"  placeholder="اینجا تایپ کنید ...">
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">واحد</label>
            <select class="custom-select" formControlName="GostarehVahed" >
              <option value="0">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.id">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">حد مجاز خطا</label>
            <input formControlName="HadMojaz" type="text"  class="form-control EnglishClm"  placeholder="اینجا تایپ کنید ...">
          </div>


          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">واحد</label>
            <select class="custom-select" formControlName="HadMojazVahed" >
              <option value="0">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.id">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>
          </div>

        </div>

        <button type="button" *ngIf="Edit_DataList_Gostareh_Indxer==-1" (click)="OnAdd_Gostareh()"  class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن به جدول </button>
        <button type="button" *ngIf="Edit_DataList_Gostareh_Indxer>-1" (click)="OnAdd_Gostareh()"  class="btn btn-warning" style="margin-left: 5px;"><i class="fa  fa-edit"></i> ویرایش گسترده کاری </button>

        <div class="table-responsive" *ngIf="DataList_Gostareh.length>0">
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>کمینه</th>
                <th>پیشینه</th>
                <th>زینه</th>
                <th>واحد</th>
                <th>حد مجاز خطا</th>
                <th>واحد</th>
                <th>امکانات</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of DataList_Gostareh">
                <td>{{DataList_Gostareh.indexOf(item)+1}}</td>
                <td>{{item.min}}</td>
                <td>{{item.max}}</td>
                <td>{{item.zineh}}</td>
                <td>
                  <div innerHTML="{{item.vahed_title}}"></div>
                </td>
                <td>{{item.error}}</td>
                <td>
                  <div innerHTML="{{item.error_vahed_title}}"></div>
                </td>
                <td>
                  <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                    <div class="btn-group" role="group">
                        <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            امکانات
                        </button>
                        <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                          <a style="cursor: pointer;" (click)="Edit_DataList_Gostareh(DataList_Gostareh.indexOf(item))" class="dropdown-item" ><i class="fa fa-edit"></i> ویرایش </a>
                          <a style="cursor: pointer;" (click)="Delete_DataList_Gostareh(DataList_Gostareh.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> حذف </a>
                        </div>
                    </div>
                </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <br/>
        <hr/>

        <h5>اطلاعات افراد مجاز به کار</h5>
        <br/>

        <div class="row">
          <div class="form-group col-md-6" >
            <label for="exampleInputEmail1">نام کالیبره کننده</label>
            <select class="custom-select" formControlName="AfradMojaz">
              <option value="0">انتخاب کنید</option>
              <option *ngFor="let item of DataList_ExpertCalibration" [value]="item.id">{{item.name}} {{item.familly}}</option>
            </select>
          </div>
        </div>

        <button type="button" (click)="OnAdd_AfradMojaz()"  class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن به جدول </button>

        <div class="table-responsive" *ngIf="DataList_AfradMojaz.length>0">
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>نام و نام خانوادگی</th>
                <th>امکانات</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of DataList_AfradMojaz">
                <td>{{DataList_AfradMojaz.indexOf(item)+1}}</td>
                <td>{{item.title}}</td>
                <td>
                  <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                    <div class="btn-group" role="group">
                        <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            امکانات
                        </button>
                        <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                          <a style="cursor: pointer;" (click)="Delete_DataList_AfradMojaz(DataList_AfradMojaz.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> حذف </a>
                        </div>
                    </div>
                </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <br/>
        <hr/>

        <h5>اطلاعات فنی</h5>
        <br/>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">مشخصات فنی</label>
            <textarea formControlName="TechnicalSpecifications" type="text"   class="form-control"  placeholder="اینجا تایپ کنید ..."></textarea>
            <small *ngIf="!get_Form_TechnicalSpecifications().valid && get_Form_TechnicalSpecifications().touched" class="form-text text-muted MyErrorRedColor">مشخصات فنی را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">توضیحات</label>
            <textarea formControlName="TechnicalDsc" type="text"   class="form-control"  placeholder="اینجا تایپ کنید ..."></textarea>
            <small *ngIf="!get_Form_TechnicalDsc().valid && get_Form_TechnicalDsc().touched" class="form-text text-muted MyErrorRedColor">توضیحات را وارد نمائید.</small>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">هشدارهای کار</label>
            <textarea formControlName="JobAlerts" type="text"   class="form-control"  placeholder="اینجا تایپ کنید ..."></textarea>
            <small *ngIf="!get_Form_JobAlerts().valid && get_Form_JobAlerts().touched" class="form-text text-muted MyErrorRedColor">هشدارهای کار را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">شرایط محیطی</label>
            <textarea formControlName="EnvironmentalConditions" type="text"   class="form-control"  placeholder="اینجا تایپ کنید ..."></textarea>
            <small *ngIf="!get_Form_EnvironmentalConditions().valid && get_Form_EnvironmentalConditions().touched" class="form-text text-muted MyErrorRedColor">شرایط محیطی را وارد نمائید.</small>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">شرایط نگهداری</label>
            <textarea formControlName="ConditionKeep" type="text"   class="form-control"  placeholder="اینجا تایپ کنید ..."></textarea>
            <small *ngIf="!get_Form_ConditionKeep().valid && get_Form_ConditionKeep().touched" class="form-text text-muted MyErrorRedColor">هشدارهای کار را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">شرایط جابجایی</label>
            <textarea formControlName="ConditionTransport" type="text"   class="form-control"  placeholder="اینجا تایپ کنید ..."></textarea>
            <small *ngIf="!get_Form_ConditionTransport().valid && get_Form_ConditionTransport().touched" class="form-text text-muted MyErrorRedColor">شرایط محیطی را وارد نمائید.</small>
          </div>
        </div>


        <div [hidden]="get_Form_NeedCalibration().value=='0'">
          <br/>
          <hr/>
          <h5>اطلاعات کالیبراسیون</h5>
          <br/>

          <div class="row">

            <div class="form-group col-md-6">
              <label for="exampleInputEmail1">شرکت کالیبره کننده - پیمانکار</label>
              <select class="custom-select" (change)="ReadData_Contracto_CalibratingCustomer()" formControlName="CalibratingCompany" >
                <option value="0">انتخاب کنید</option>
                <option value="-1">بهفا</option>
                <option *ngFor="let item of DataList_Contractor" [value]="item.id">{{item.title}}</option>
              </select>
            </div>

            <div class="form-group col-md-3" [hidden]="get_Form_CalibratingCompany().value=='-1'" >
              <label for="exampleInputEmail1">شرکت کالیبره کننده - مشتری</label>
              <select class="custom-select" formControlName="CalibratingCustomer" >
                <option value="0">انتخاب کنید</option>
                <option *ngFor="let item of DataList_Contractor_CalibratingCustomer" [value]="item.id">{{item.title}}</option>
              </select>
            </div>

            <div class="form-group col-md-6" [hidden]="get_Form_CalibratingCompany().value!='-1'">
              <label for="exampleInputEmail1">نام کالیبره کننده</label>
              <select class="custom-select" formControlName="CalibratingName">
                <option value="0">---</option>
                <option *ngFor="let item of DataList_ExpertCalibration" [value]="item.id">{{item.name}} {{item.familly}}</option>
              </select>
            </div>

            <div class="form-group col-md-3" [hidden]="get_Form_CalibratingCompany().value=='-1'">
              <label for="exampleInputEmail1">نام کالیبره کننده</label>
              <input formControlName="CalibratingNameType" type="text"  class="form-control " placeholder="اینجا تایپ کنید ...">
            </div>


          </div>

          <div class="row">
            <div class="form-group col-md-6">
              <label for="exampleInputEmail1">Certificate No</label>
              <input formControlName="CertificateNo" type="text"  style="font-family: Arial, Helvetica, sans-serif;"  class="form-control EnglishClm"  placeholder="اینجا تایپ کنید ...">
              <small *ngIf="!get_Form_CertificateNo().valid && get_Form_CertificateNo().touched" class="form-text text-muted MyErrorRedColor">Certificate No را وارد نمائید.</small>
            </div>
            <div class="form-group col-md-6">
              <label for="exampleInputEmail1">عدم‌قطعیت</label>
              <input formControlName="Uncertainty" type="text"  style="font-family: Arial, Helvetica, sans-serif;"  class="form-control EnglishClm"  placeholder="اینجا تایپ کنید ...">
              <small *ngIf="!get_Form_Uncertainty().valid && get_Form_Uncertainty().touched" class="form-text text-muted MyErrorRedColor">عدم‌قطعیت را وارد نمائید.</small>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-3">
              <label for="exampleInputEmail1">نوع تاریخ Cal. Due</label>
              <select class="custom-select" formControlName="CalDueType" >
                <option value="0">تاریخ شمسی</option>
                <option value="1">تاریخ میلادی</option>
              </select>
            </div>
            <div class="form-group col-md-3" [hidden]="get_Form_CalDueType().value=='0'">
              <label for="exampleInputEmail1">Cal. Due</label>
              <input formControlName="CalDueMiladi" type="date"  style="font-family: Arial, Helvetica, sans-serif;"  data-date-format="DD MMMM YYYY" class="form-control"  placeholder="اینجا تایپ کنید ...">
              <small *ngIf="!get_Form_CalDueMiladi().valid && get_Form_CalDueMiladi().touched" class="form-text text-muted MyErrorRedColor">Cal. Due را وارد نمائید.</small>
            </div>
            <div class="form-group col-md-3" [hidden]="get_Form_CalDueType().value=='1'">
              <label for="exampleInputEmail1">Cal. Due</label>
              <input type="text" formControlName="CalDueShamsi" #datepickerCalDueShamsi placeholder="اینجا تایپ کنید ..."   class="form-control" />
              <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerCalDueShamsi"></ng-persian-datepicker>
            </div>

            <div class="form-group col-md-3">
              <label for="exampleInputEmail1">نوع تاریخ Cal. DATE</label>
              <select class="custom-select" formControlName="CalDATEType" >
                <option value="0">تاریخ شمسی</option>
                <option value="1">تاریخ میلادی</option>
              </select>
            </div>
            <div class="form-group col-md-3" [hidden]="get_Form_CalDATEType().value=='0'">
              <label for="exampleInputEmail1">Cal. DATE</label>
              <input formControlName="CalDATEMiladi" type="date"  style="font-family: Arial, Helvetica, sans-serif;"  data-date-format="DD MMMM YYYY" class="form-control"  placeholder="اینجا تایپ کنید ...">
              <small *ngIf="!get_Form_CalDATEMiladi().valid && get_Form_CalDATEMiladi().touched" class="form-text text-muted MyErrorRedColor">Cal. DATE را وارد نمائید.</small>
            </div>
            <div class="form-group col-md-3" [hidden]="get_Form_CalDATEType().value=='1'">
              <label for="exampleInputEmail1">Cal. DATE</label>
              <input formControlName="CalDATEShamsi" type="text" #datepickerCalDATEShamsi placeholder="اینجا تایپ کنید ..."   class="form-control" />
              <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerCalDATEShamsi"></ng-persian-datepicker>
            </div>


          </div>

          <div class="row">

            <div class="form-group col-md-6">
              <label for="exampleInputEmail1">قیمت</label>
              <input formControlName="CalibratingPrice" type="number"   class="form-control"  placeholder="اینجا تایپ کنید ...">
              <small *ngIf="!get_Form_CalibratingPrice().valid && get_Form_CalibratingPrice().touched" class="form-text text-muted MyErrorRedColor">قیمت را وارد نمائید.</small>
            </div>
            <div class="form-group col-md-6">
              <label for="exampleInputEmail1">واحد پولی</label>
              <select class="custom-select" formControlName="CalibratingPriceVahed">
                <option value="0">انتخاب نمائید</option>
                <option *ngFor="let item of DataList_Money" [value]="item.id">{{item.title}}</option>
              </select>
            </div>

          </div>

          <br/>
          <hr/>
          <br/>

          <div class="row">
            <div class="form-group col-md-6">
              <label for="exampleInputEmail1">
                 فایل/های ضمیمه
                <button (click)="Remove_uploadImage1()"  type="button" *ngIf="UploadImageSrc"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
              </label>
              <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
              <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file" class="form-control"  placeholder="اینجا تایپ کنید ...">
            </div>
          </div>

          <button type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc" class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن ضمیمه </button>

          <br/>

          <div class="table-responsive" *ngIf="UploadImageSrc_List.length>0">
            <table class="mb-0 table table-bordered table-3 text-center table-striped">
              <thead style="background-color: #489b39; color: white;">
                <tr>
                  <th>#</th>
                  <th>فایل</th>
                  <th>امکانات</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of UploadImageSrc_List" >

                    <td>{{UploadImageSrc_List.indexOf(item)+1}}</td>
                    <td>
                      <a target="_blank" *ngIf="item.includes('.pdf')"  href="{{BaseUrl}}File/DeviceBehfa/{{item}}" class="btn btn-success" ><i class="fa fa-file-pdf-o"></i> PDF </a>
                    </td>
                    <td>
                        <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                          <div class="btn-group" role="group">
                              <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  امکانات
                              </button>
                              <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                  <a style="cursor: pointer;" (click)="UploadImageSrc_List_Delete(UploadImageSrc_List.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> حذف </a>
                              </div>
                          </div>
                      </div>
                    </td>

                </tr>
              </tbody>
            </table>
          </div>

          <br/>

        </div>



        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
        <button *ngIf="!InProccessing" type="submit" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
        <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-left: 5px;"><i class="fa fa-times-rectangle" ></i> لغو </button>
        <button (click)="OnBack_DeviceBehfaList()" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>
      </form>
  </div>
</div>

